export const DISPLAY_SHIPPER_DISABLED_FIELDS = new Set([
  'unitUpc',
  'innerPackUpc',
  'innerPackGtin',
]);
